// extracted by mini-css-extract-plugin
export default {"illustrationContainer":"UhThUl1992qXIljKf7ON"};